import Icon from '../components/Icon.vue'

Icon.register({
  'list-ol': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M3.3 139.5c0-7.5 3.9-11.6 11.6-11.6h15.1v-39.9c0-5.2 0.5-10.5 0.5-10.5h-0.4s-1.8 2.7-2.8 3.7c-4.5 4.3-10.5 4.5-15.7-1.1l-5.5-6.2c-5.3-5.3-5-11.2 0.5-16.4l21.7-19.9c4.4-4.1 8.4-5.7 14.4-5.7h12.1c7.7 0 11.7 3.9 11.7 11.6v84.4h15.5c7.7 0 11.6 4.1 11.6 11.6v8.9c0 7.5-3.9 11.6-11.6 11.6h-67.3c-7.7 0-11.6-4.1-11.6-11.6v-8.9zM2.2 304.6c0-47.3 51-56.4 51-69.2 0-7.2-6-8.8-9.3-8.8-3.2 0-6.5 1.1-9.5 3.9-5.1 4.9-10.5 7-16.1 2.5l-8.6-6.8c-5.8-4.6-7.2-9.8-2.8-15.4 6.7-8.8 19.1-18.7 40.4-18.7 19.4 0 44.5 10.5 44.5 39.6 0 38.3-46.8 46.4-48.7 56.9h39c7.5 0 11.6 4 11.6 11.4v8.8c0 7.4-4 11.4-11.6 11.4h-67.9c-7 0-12.1-4-12.1-11.4v-4h0zM5.7 454.6l5.6-9.3c3.9-6.7 9.1-7 15.6-3.2 4.9 2.1 9.6 3.2 14.4 3.2 10.2 0 14.4-3.5 14.4-8.2 0-6.7-5.6-9.1-15.9-9.1h-4.7c-6 0-9.3-2.1-12.3-7.9l-1-1.9c-2.5-4.7-1.2-9.8 2.8-14.9l5.6-7c6.8-8.4 12.3-13.5 12.3-13.5v-0.4s-4.2 1.1-12.6 1.1h-13c-7.5 0-11.4-4-11.4-11.4v-8.8c0-7.5 3.9-11.4 11.4-11.4h58.5c7.5 0 11.4 4 11.4 11.4v3.3c0 5.8-1.4 9.8-5.1 14.2l-17.5 20.1c19.6 5.1 28.7 20.5 28.7 34.8 0 21.4-14.4 44.1-48.5 44.1-16.6 0-28.2-4.7-35.9-9.5-5.8-4.2-6.3-9.8-2.6-15.9zM144 132c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352zM144 292c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352zM144 452c-8.8 0-16-7.2-16-16v-40c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v40c0 8.8-7.2 16-16 16h-352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/list-ol.js
// module id = null
// module chunks = 